export default __webpack_public_path__ + "static/media/javascript.a10d3785.png";